
export const getDefaultState = () => {
  return {
    librariesList: [],
    isFetchingLibraries: false,
  };
};
export const state = getDefaultState();
